<template>
  <div class="xq-menu-icon">
    <!-- :class="{'menu-worker-icon':iconName && (iconName =='houseWorkorder')}" -->
    <SVGBox
      v-show="svgConf.show"
      :width="svgConf.width"
      :height="svgConf.height"
      :fill="svgConf.fill && svgConf.fill.length ? svgConf.fill : undefined "
      :url="svgConf.url"
    />
    <img
      v-if="!svgConf.show"
      class="xq-menu-icon-img"
      :src="require(`@/assets/icons/menu/level2/${iconName || 'default'}.svg`)"
    >
  </div>
</template>

<script>
import { request } from "@/utils/request";

import SVGBox from "@/components/SVGBox"

export default {
  name: 'IconBox',
  components: {
    SVGBox
  },
  props: {
    iconName: {
      type: String,
      require: true,
    },
  },
  data () {
    return {
      svgConf: {
        show: false,
        url: "",
        width: "",
        height: "",
        fill: "",
      },
    };
  },
  created () {
    this.getSVGData()
  },
  methods: {
    async getSVGData () {
      try {
        if (!this.iconName) return

        const baseUrl = process.env.BASE_URL;
        const svgUrl = `${baseUrl}config/icons/${this.iconName || "default"
          }.svg`;
        const dataUrl = `//${location.host}${baseUrl}config/icons/${this.iconName}.json`;

        const res = await request({ url: dataUrl });

        if (res && res.width) {
          // const r = JSON.parse(res);
          const { width, color } = res;
          const widthFix = width >= 24 ? 18 : width;

          this.svgConf = {
            width: widthFix,
            height: widthFix,
            show: true,
            url: svgUrl,
            fill: color,
          };
        }
      } catch (error) { }
    },
  },
};
</script>

<style lang="less" scoped>
.xq-menu-icon {
  margin-right: 8px;

  &-img {
    width: 18px;
    height: 18px;
  }
}
</style>